(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-dropdown-menu"] && !Shopify.designMode) return;
  try {
    const initializeShopHoverMenus = (scope = document) => {
    const desktopPointer = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

    scope.querySelectorAll('.dab-header-shop').forEach((menu) => {
      if (menu.dataset.hoverMenuReady === 'true') return;

      const details = menu.querySelector(':scope .dab-header-shop__row > details');
      const toggle = details?.querySelector(':scope > summary');
      if (!details || !toggle) return;

      let closeTimer;

      const setExpanded = (expanded) => {
        details.open = expanded;
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      };

      menu.addEventListener('pointerenter', () => {
        if (!desktopPointer.matches) return;
        window.clearTimeout(closeTimer);
        setExpanded(true);
      });

      menu.addEventListener('pointerleave', () => {
        if (!desktopPointer.matches) return;
        closeTimer = window.setTimeout(() => setExpanded(false), 140);
      });

      details.addEventListener('toggle', () => {
        toggle.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      });

      menu.dataset.hoverMenuReady = 'true';
    });
  };

  initializeShopHoverMenus();
  document.addEventListener('shopify:section:load', (event) => initializeShopHoverMenus(event.target));
  } catch(e) { console.error(e); }
})();

})();
